import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { KnbrRequestQuoteConfirmationComponent } from './knbr-request-quote-confirmation/knbr-request-quote-confirmation.component';

@NgModule({
  declarations: [],
  imports: [CommonModule,
    ConfigModule.withConfig({
            cmsComponents: {
                RequestQuoteConfirmationProductsFlexComponent: {
                    component: KnbrRequestQuoteConfirmationComponent,
                }
            },
        } as CmsConfig),
        KnbrRequestQuoteConfirmationComponent,
      ],
})
export class KnbrRequestQuoteConfirmationModule {}
